import { sanitizeCsvValue } from './sanitizeCsvValue';

import { ReportColumnConfig } from '../types';

export const mapReportData = <T>(
  data: T[],
  columns: ReportColumnConfig<T>[],
  context?: any
): Record<string, string | number | boolean>[] => {
  return data.map((item) => {
    const row: Record<string, string | number | boolean> = {};

    columns.forEach(({ key, getValue }) => {
      row[key] = sanitizeCsvValue(getValue(item, context));
    });

    return row;
  });
};
